import React from "react";
import Modal from "react-bootstrap/Modal";
import OrderProductsTable from "components/Tables/OrderProductsTable";

export default function OrderProductsModal({ orderId, show, handleClose, headerText }) {
  return (
    <>
      <Modal size="xl" dialogClassName="my-modal" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ margin: 0 }}>{headerText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderProductsTable modalOpen={show} orderId={orderId} />
        </Modal.Body>
      </Modal>
    </>
  );
}
